module.exports = __webpack_public_path__ + "static/img/etc_04.168bdbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/etc_04.jpg
// module id = mAa7
// module chunks = 0